module.exports = __webpack_public_path__ + "img/popup_left.874fc723.png";